import type { IErrorService } from "@microsoft/applicationinsights-angularplugin-js";

export class CustomErrorHandler implements IErrorService {
  handleError(error: any): void {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
